import React from "react";
import Select from "react-select";

const formatOptionLabel = ({ value, label, image }) => (
  <div className="frameRow">
    {image && (
      <div className="frameColumnImg">
        <img src={image} height="60%" width="60%"></img>
      </div>
    )}

    <div className="frameColumn">
      <div>{label}</div>
    </div>
  </div>
);

export default function SelectOptionCart({ optionsUtility, option }) {
  const handleSelectChange = (selectedValue) => {
    optionsUtility.changeOptionToLabel(option.name, selectedValue.label);
  };
  let selected = option.values.find((value) => value.selected);
  if (option.handle == "floater-frame") {
    return (
      <div className="optionSelect">
        <Select
          onChange={handleSelectChange}
          name={option.name}
          options={option.values}
          key={option.name}
          value={selected}
          formatOptionLabel={formatOptionLabel}
        />
      </div>
    );
  }
  return (
    <div className="optionSelect">
      <Select
        onChange={handleSelectChange}
        name={option.name}
        options={option.values}
        key={option.name}
        value={option.values.find((value) => value.selected)}
      />
    </div>
  );
}
